<template>
  <message type="info">
    Posts are flagged based on a list of keywords that may be of concern.
    The Flagged Posts section is purely assistive and not intended to be
    exhaustive of all potential posts of interest. It should be used in
    conjunction with a manual review of all client posts. We continue to
    refine the flagging criteria and welcome your feedback.
  </message>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Message from '@/components/message/Message.vue';

export default defineComponent({
  components: { Message },
});
</script>
